import type { Resource } from '@/features/resource/types'

/**
 * Three of the Support Toolbox actions (Resync from monolith, Sync component statuses, Republish)
 * re-emit Pulsar projections sourced from the monolith. For LOCAL-controlled resources those
 * projections aren't filled from the monolith path — configuration lives in device-manager's
 * `resource.json` — so the buttons are meaningless and we hide them.
 *
 * `controlMode` is optional on the API type; un-migrated resources may arrive with it missing.
 * Treat the missing case as "show" so we don't regress today's behaviour for resources that
 * haven't been classified yet.
 */
export function isMonolithSupportActionVisible(resource: Resource | undefined): boolean {
  return resource?.controlMode !== 'LOCAL'
}
